const topics = [
  { label: '暑期档', count: 286, hot: true },
  { label: '悬疑剧', count: 198, hot: true },
  { label: '科幻大片', count: 165, hot: true },
  { label: '国漫崛起', count: 142, hot: false },
  { label: '怀旧港片', count: 127, hot: false },
  { label: '韩剧推荐', count: 203, hot: true },
  { label: '高分纪录片', count: 89, hot: false },
  { label: '治愈系电影', count: 156, hot: false },
  { label: '推理综艺', count: 178, hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            大家都在讨论的影视话题，加入观影潮流
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, idx) => (
              <a
                key={idx}
                href="#"
                className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                  topic.hot
                    ? 'bg-accent-50 border-accent-200 hover:bg-accent-100 hover:border-accent-300'
                    : 'bg-background-100 border-background-200 hover:bg-background-200 hover:border-background-300'
                }`}
                style={{ animationDelay: `${idx * 60}ms` }}
              >
                <span className={`text-sm font-medium ${
                  topic.hot ? 'text-accent-700' : 'text-foreground-700'
                }`}>
                  {topic.label}
                </span>
                <span className={`text-[11px] px-1.5 py-0.5 rounded-full ${
                  topic.hot
                    ? 'bg-accent-200/50 text-accent-600'
                    : 'bg-background-200 text-foreground-400'
                }`}>
                  {topic.count}
                </span>
                {topic.hot && (
                  <span className="text-accent-500">
                    <i className="ri-fire-line text-xs"></i>
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}